var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.value ? _vm.trueColor : _vm.falseColor,"icon":""},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.value ? _vm.trueIcon : _vm.falseIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }